const ArrowDownIcon = () => {
  return (
    <svg
      width="11"
      height="7"
      viewBox="0 0 11 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.02825 0.928639C1.39925 0.557641 2.00075 0.557641 2.37175 0.928639L5.5 4.05689L8.62825 0.928639C8.99925 0.557641 9.60075 0.557641 9.97175 0.928639C10.3427 1.29964 10.3427 1.90114 9.97175 2.27214L6.17175 6.07214C5.80075 6.44314 5.19925 6.44314 4.82825 6.07214L1.02825 2.27214C0.65725 1.90114 0.65725 1.29964 1.02825 0.928639Z"
        fill="#9CD3D3"
      />
    </svg>
  );
};
export default ArrowDownIcon;
